export const COLOR_OPTIONS = {
  red: "#FF5B59",
  orange: "#FD9038",
  yellow: "#F5B900",
  lime: "#C5E311",
  green: "#22C55E",
  teal: "#14B8A6",
  blue: "#0EA5E9",
  indigo: "#6366F1",
  violet: "#9162F9",
  purple: "#CE67DB",
  pink: "#F65385",
  gray: "#D1D3D6",
} as const

export type ColorKey = keyof typeof COLOR_OPTIONS
